import type { ReactNode } from 'react';
import { cx } from '@/utils/cx';
import styles from '@/styles/components/Section/style.scss';

interface SectionProps {
  title: string;
  /** Rendered on the right of the title (e.g. an "Add" button). */
  action?: ReactNode;
  /** Use when the title labels a form control. */
  htmlFor?: string;
  children: ReactNode;
  className?: string;
}

/** A titled block inside a card or modal. */
export function Section({ title, action, htmlFor, children, className }: SectionProps) {
  return (
    <section className={cx(styles.section, className)}>
      <div className={styles.head}>
        {htmlFor ? (
          <label className={styles.title} htmlFor={htmlFor}>
            {title}
          </label>
        ) : (
          <span className={styles.title}>{title}</span>
        )}
        {action}
      </div>
      {children}
    </section>
  );
}

/** Bordered box with sunken background. */
export function Panel({ children, tone, className }: { children: ReactNode; tone?: 'primary' | 'amber'; className?: string }) {
  return <div className={cx(styles.panel, tone && styles[tone], className)}>{children}</div>;
}

/** Label / value line, e.g. totals. */
export function KeyValue({ label, value, emphasis }: { label: ReactNode; value: ReactNode; emphasis?: boolean }) {
  return (
    <div className={cx(styles.kv, emphasis && styles.kvEmphasis)}>
      <span className={styles.kvLabel}>{label}</span>
      <span className={styles.kvValue}>{value}</span>
    </div>
  );
}
